import GroupRestrictionsDrawer from "./GroupRestrictionsDrawer";
export default GroupRestrictionsDrawer;
